<script setup lang="ts">
import { LoaderCircle } from '@lucide/vue';
import OtCard from '../components/Card.vue';

interface Props {
    loading: boolean;
    standalone?: boolean;
}
withDefaults(defineProps<Props>(), {
    standalone: false,
});
</script>

<template>
    <div>
        <div v-if="loading">
            <div v-if="standalone" class="flex justify-center items-center">
                <loader-circle class="h-16 w-16 text-green-700 animate-spin" />
            </div>
            <ot-card v-else class="p-5 overflow-hidden flex justify-center items-center">
                <loader-circle class="h-16 w-16 text-green-700 animate-spin" />
            </ot-card>
        </div>
        <slot v-else />
    </div>
</template>
